import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IconPickerService } from './icon-picker.service';

@Component({
  selector: 'mvta-icon-picker',
  templateUrl: 'icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  providers: [IconPickerService]
})
export class IconPickerComponent implements OnInit {

  @Input() src: string;
  @Output() srcChange = new EventEmitter();
  @Output() modeChange = new EventEmitter();

  @Input() showRemove = true;
  @Input() showChange = true;
  @Input() showInstructions = true;
  @Input() changeText = 'Cambiar';
  @Input() removeText = 'Quitar';
  @Input() cancelSelectionText = 'Cancelar';

  @Input() imagesSize = {
    width: 256,
    height: 256
  };

  MAX_IMAGE = {
    WIDTH: 256,
    HEIGHT: 256
  }; // fHD
  selectionMode = false;
  uploading = false;
  changed = false;
  loadingImages = false;
  images = [];
  imagesEdit = {
    show: false,
    type: ''
  };

  constructor(private iconPickerService: IconPickerService, private toastrService: ToastrService, private modalService: NgbModal) { }

  ngOnInit() {
    this.loadingImages = true;
    this.iconPickerService.getImages()
      .subscribe((response) => {
        this.images = (response.images || [])
          .map((i) => {
            return {
              src: i.link
            };
          });
        this.loadingImages = false;
      }, (error) => {
        this.images = [];
        this.loadingImages = false;
      });
  }

  onDeleteImage() {
    this.src = '';
    this.srcChange.emit(this.src);
  }

  onChangeImage() {
    this.srcChange.emit(this.src);
    this.setSelectionMode(true);
  }

  onSelectImage(ev) {
    this.src = ev;
    console.log('selectedImage!', this.src);
    this.srcChange.emit(this.src);
    this.setSelectionMode(false);
  }

  onFileImageChange(fileInput) {
    const file = fileInput;
    this.uploading = true;
    const reader = new FileReader();
    reader.onload = () => this.toJpg(reader.result);
    reader.readAsDataURL(file);
  }

  setSelectionMode(status: boolean) {
    this.selectionMode = status;
    this.modeChange.emit(this.selectionMode ? 'edit' : 'show');
  }

  toJpg(data) {
    const image = new Image();
    image.onload = () => {
      // Max width
      if (image.width > this.MAX_IMAGE.WIDTH) {
        this.toastrService.info('Las imágenes deben tener un máximo de 1920px de ancho. Se escalará la imagen');
        const ratio = this.MAX_IMAGE.WIDTH / image.width;
        image.width = this.MAX_IMAGE.WIDTH;
        image.height = image.height * ratio;
      }
      // Max height
      if (image.height > this.MAX_IMAGE.HEIGHT) {
        this.toastrService.info('Las imágenes deben tener un máximo de 1080px de alto. Se escalará la imagen');
        const ratio = this.MAX_IMAGE.HEIGHT / image.height;
        image.height = this.MAX_IMAGE.HEIGHT;
        image.width = image.width * ratio;
      }

      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, image.width, image.height);
      this.doUploadImage(canvas.toDataURL('image/jpeg', 0.65));
    };
    image.src = data;
  }

  doUploadImage(imageData) {
    this.iconPickerService.uploadImage(imageData)
      .subscribe((response) => {
        this.images.push({ src: response.fileName });
        this.selectionMode = false;
        this.resetFileUpload();
      }, () => {
        this.resetFileUpload();
      });
  }

  resetFileUpload() {
    this.uploading = false;
    this.changed = true;
    setTimeout(() => {
      this.changed = false;
    }, 500);
  }

  onCroppedImage(ev) {
    this.doUploadImage(ev);
  }

  onCancelImage() {
    this.selectionMode = false;
  }

  onShowCropper(modal: NgbModalRef, ev: Event) {
    if (ev && ev.preventDefault) {
      ev.preventDefault();
    }
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' });
  }

  onRemoveImageFromCloud(image, ev) {
    if (ev && ev.stopPropagation) {
      ev.stopPropagation();
    }

    const name = image.src.split('muventa/')[1];
    this.iconPickerService.deleteImage(name)
      .subscribe((r) => {
        const idx = this.images.indexOf(image);
        if (idx > -1) {
          this.images.splice(idx, 1);
        }
        this.toastrService.success('Se ha eliminado la imagen de la galeria')
      }, (e) => {
        console.log(e);
      })
  }
}
